import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllRequisitionStatusAndCounts = async(id,payload) => {
    try
    {
        const response = await axios.post(
            `${jsonConfig.apiUrl}getAllRequisitionStatusAndCounts/${id}`,payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                }
            }
        );
        return Promise.resolve(response);
    }
    catch(error)
    {
        return Promise.reject(error);
    }
}

export default getAllRequisitionStatusAndCounts